export const useMarkdownContent = (mdConfig?: any) => {
  const route = useRoute()
  const { locale } = useI18n()
  const isMarkdownRequest = route.path?.endsWith('.md')

  function stripMarkdownSlugIfApplicable() {
    // If no slug or no md, return
    if (!route.params.slug || !isMarkdownRequest) return

    // Remove .md from slug at the end
    const slugClean = (route.params.slug || '').slice(0, -3)

    // Override current route param slug for async data
    route.params.slug = slugClean
  }

  function updateEventContext(data: any) {
    // Only run on server for markdown requests
    if (import.meta.client) return

    const event = useRequestEvent()

    if (!isMarkdownRequest || !data?.pageData) {
      return
    }

    try {
      const pageData = data.pageData
      const contentType = pageData.content?.pageContent?.type
      const pageContent = pageData.content.pageContent

      // Get template function from config
      const template = mdConfig.contentTypes[contentType as keyof typeof mdConfig.contentTypes]

      if (template) {
        // Prepare options
        const options = {
          ...mdConfig.defaultOptions,
          url: route.path.replace('.md', ''),
          locale: locale.value
        }

        // Generate markdown
        const markdown = template(pageData.content, pageContent, options)

        // Store in event context for Nitro plugin
        if (markdown && event) {
          event.context.markdownContent = markdown
          event.context.layerName = mdConfig.layerName
        }
      }
    } catch {
      // Silently fail - markdown generation is optional
    }
  }

  return {
    stripMarkdownSlugIfApplicable,
    updateEventContext
  }
}
